import { Route, Switch } from "react-router";
import { useFirebase } from "../FbContex";
import DeviceCard from "../components/DeviceCard";
import Loading from "../components/Loading";
import ResWidget from "../components/ResWidget";
import Sidebar from "../components/Sidebar";
import Login from "../components/login";
import Room from "./room";
import Rooms from "./rooms";
import NotFound from "./404";
import Devices from "./devices";
import Sources from "./sources";
import Charger from "./charger";
import Temperature from "./temperature";
import Teras from "./teras";
import ForbidenArea from "../components/Forbiden";
import { useEffect } from "react";
import { activeRooms } from "../lib/selectors";

export default function Home() {
  const { loading, user, state, rooms } = useFirebase();

  useEffect(() => {
    const dark = window.matchMedia("(prefers-color-scheme: dark)");
    if (dark.matches) {
      document.documentElement.classList.add("dark");
    }
    dark.onchange = (e) => {
      if (e.matches) {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    };
  }, []);

  if (loading) return <Loading />;

  if (!user) return <Login />;
  if ((user.email + "").slice(-11) !== "@nendy.name") return <ForbidenArea />;

  return (
    <div className="mx-auto flex w-full max-w-5xl">
      <Sidebar />
      <div className="flex-1 min-w-0 min-h-screen md:pt-4 pt-24 sm:px-4">
        <Switch>
          <Route path="/" exact>
            <div className="flex flex-row justify-around mb-4 py-4 sm:px-4 sm:rounded-xl bg-gray-500/25">
              <ResWidget title="PLN" value={["220v"]} />
              <ResWidget
                title="Solar Cell"
                value={[
                  `${Number(state.data?.solar_volt) / 10}v`,
                  (Number(state.data?.solar_ma) / 1000).toFixed(2) + "A",
                ]}
              />
              <ResWidget
                title="Battrey"
                value={[
                  Number(state.data?.batt_v) / 10 + "v",
                  // Firmware sends signed mA; positive = charging.
                  (Number(state.data?.batt_ma) / 1000).toFixed(2) + "A",
                ]}
              />
            </div>
            <div className="flex flex-row flex-wrap justify-around sm:mx-0 mx-4 mb-6">
              {activeRooms(rooms).map((r) => (
                <DeviceCard key={r.id} room={r} />
              ))}
            </div>
            {/* </div> */}
          </Route>
          <Route path="/room/:slug" children={<Room />} />
          <Route path="/rooms" component={Rooms} />
          <Route path="/devices" component={Devices} />
          <Route path="/sources" component={Sources} />
          <Route path="/charger" component={Charger} />
          <Route path="/temperature" component={Temperature} />
          <Route path="/teras" component={Teras} />
          <Route path="*" component={NotFound} />
        </Switch>
      </div>
    </div>
  );
}
